import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import "./MyTable.css";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function StockDetailsBody({
  data,
  updateDetails,
  changeFlag
}) {

  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        <div>
          <Button
            className="btn btn-warning"
            id={`view-${row.id}`}
            onClick={(e) => updateDetails(row)}
            style={{ marginLeft: "5px" }}
            key={row.id}
          >
            <i className="fa fa-eye" />
          </Button>

          <UncontrolledTooltip placement="right" target={`view-${row.id}`}>
            view
          </UncontrolledTooltip>
        </div>
      </span>
    );
  };



  return (
    <Card>
      <CardHeader className="carheaderSmall">
        <strong>Stock Details</strong>
      </CardHeader>

      <CardBody>
        <Row className="justify-content-start">
          <Button
            className="btn btn-warning"
            id='addItem'
            name='addItem'
            onClick={(e) => changeFlag()}
            style={{ marginLeft: "20px", marginBottom: "10px" }}

          >
            Add Item
          </Button>
        </Row>
        <BootstrapTable
          data={data}
          version="4"
          condensed={true}
          striped
          hover
          pagination
          search
          options={options}
          exportCSV
          csvFileName="Stock_Details.csv"
        >
          <TableHeaderColumn
            isKey
            dataField="id"
            export={false}
            hidden={true}
          >
            ID
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="name"
            csvHeader="Item name"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Item name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="itemCode"
            csvHeader="Item code"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Item Code
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="category"
            csvHeader="category"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Category
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="purchasePrice"
            csvHeader="purchasePrice"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Purchase Price
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="salePrice"
            csvHeader="salePrice"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Sale Price
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="mrp"
            csvHeader="mrp"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            MRP
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="inStock"
            csvHeader="inStock"
            dataSort
            tdStyle={{ width: "15%", whiteSpace: "normal" }}
            thStyle={{ width: "15%", whiteSpace: "normal" }}
            filter={{
              type: "NumberFilter",
              delay: 1000,
              numberComparators: ["=", ">", "<"],
            }}
          >
            In Stock
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="stockValue"
            csvHeader="stockValue"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataSort
            tdStyle={{ whiteSpace: "normal" }}
            thStyle={{ whiteSpace: "normal" }}
          >
            Stock Value
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            dataFormat={cellButton}
            hiddenOnInsert
            export={false}
          >
            Actions
          </TableHeaderColumn>
        </BootstrapTable>
      </CardBody>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/StockDetailsBody.js